import React from 'react'
import './styles.scss'
import { message } from 'antd'

import { bindActionCreators } from 'redux'
import { connect }            from 'react-redux'
import { withRouter }         from 'react-router-dom'

import BlockUi from 'react-block-ui'
import 'react-block-ui/style.css'

import CloudFlyerAPI from '../../../api/CloudFlyerAPI'

import Header  from './header'
import Files   from './files'

class FilesTransfers extends React.Component {

  constructor (props) {
    super(props)
    this.state = {
      files              : [],
      files_loading      : false,

      is_transfer_agent_running : false,
      transfer_server_error     : false,

      files_error      : null,
      transfer_error   : null,
      heartbeat        : 1000,
      is_heartbeat     : false,
      transfer_loading : false
    }
  }

  componentWillReceiveProps(props) {
    let run_heartbeat = false
    if(!this.state.is_heartbeat && ((!this.state.connection_key && props.connection_key) ||
      (this.state.transfer_server_error && !props.transfer_server_error) ||
      (!this.state.is_transfer_agent_running && props.is_transfer_agent_running))){
      run_heartbeat = true
    }

    this.setState({
      is_transfer_agent_running : props.is_transfer_agent_running,
      transfer_server_error     : props.transfer_server_error,
      connection_key            : props.connection_key
    }, ()=> (run_heartbeat && this.props.is_transfer_agent_running && !this.props.transfer_server_error) ? this.setState({is_heartbeat:true}, this.heartbeat(0)) : null)
  }

  on_cancel = file => {
    if(!file){
      file = this.state.files[0]
    }

    if(!file || !file.transferID){
      return
    }

    this.setState({transfer_loading:true})
    let $this = this

    CloudFlyerAPI.file_catalyst
      .transfers
      .cancel(file.transferID)
      .then(res =>{
        $this.setState({transfer_loading : false})
        message.success('Transfers cancelled successfully')
      })
      .catch(e =>{
        console.error(e)
        this.setState({transfer_loading:false})
        message.error('Failed to cancel transfer, please try again')
      })
  }

  heartbeat = timeout => {
    let $this = this

    if(!this.props.is_transfer_agent_running){
      return console.info('Transfers: stopped')
    }

    if(this.props.transfer_server_error){
      return console.info('Transfers: stopped')
    }

    setTimeout(()=> {
      CloudFlyerAPI.file_catalyst
        .transfers
        .status()
        .then(res =>{
          let transfer_error = null
          let files = []
          for (let key in ((res||{}).data||{}).allTransfers) {
            let transfers = ((res||{}).data||{}).allTransfers[key].fileTransfers
            for (let tkey in transfers) {
              transfers[tkey].transferID = ((res||{}).data||{}).allTransfers[key].transferID
            }
            files = files.concat(transfers)
            if(((res||{}).data||{}).allTransfers[key].transferErrors.length > 0){
              transfer_error = ((res||{}).data||{}).allTransfers[key].transferErrors[0].error
            }
          }

          $this.setState({
            files         : files,
            files_loading : false,
            files_error   : null,
            transfer_error
          }, $this.heartbeat)
        })
        .catch(e =>{
          console.info('Transfers: error')
          console.error(e)
          $this.heartbeat()
        })
    }, timeout ? timeout : $this.state.heartbeat);
  }

  render() {
    const {files, transfer_loading, files_loading,
      is_transfer_agent_running,
      transfer_server_error, connection_key} = this.state
    let {on_retry} = this.props

    return (
      <BlockUi className='files-transfers' blocking={transfer_loading}>

        <Header title={'Transfers'}
                disabled  = {files.length === 0}
                on_cancel = {this.on_cancel.bind(this)}/>

        <hr/>

        <Files
          key                       = {'Files'}
          files                     = {files}
          files_loading             = {files_loading}
          is_transfer_agent_running = {is_transfer_agent_running}
          transfer_server_error     = {transfer_server_error}
          on_cancel                 = {this.on_cancel}
          on_retry                  = {()=> connection_key ? this.heartbeat(0) : on_retry()}
        />
      </BlockUi>
    )
  }
}

export default withRouter(connect(
  ({}) => {
    return {}
  }, (dispatch) => bindActionCreators({

  }, dispatch))(FilesTransfers))
